var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_4230_9212)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#D0BBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4659 30.4513V21.5156M20.4659 21.5156L16.5938 25.3878M20.4659 21.5156L24.338 25.3878",
    stroke: "white",
    strokeWidth: 1.78714,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5297 25.6874C9.24618 22.0138 8.84925 13.7732 15.1042 12.2839C20.3463 10.8542 24.2381 15.1631 24.9331 17.6452C26.6209 17.5459 29.4014 17.6453 30.5923 20.6237C31.8287 23.7158 29.9966 25.6872 28.5073 27.1765",
    stroke: "white",
    strokeWidth: 1.78714,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4230_9212",
    x1: 2.67708,
    y1: 1,
    x2: 43.0823,
    y2: 1.10106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F2D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841346,
    stopColor: "#7643BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E48CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPurple);
export default __webpack_public_path__ + "static/media/upload_purple.23bdd86a22f9ceb6c6f11da0924e744d.svg";
export { ForwardRef as ReactComponent };